/**
 * 使用常量替代 mutation 事件类型
 */
// 设置tags
export const SET_TAGS = 'SET_TAGS';
// 添加tag
export const ADD_TAG = 'ADD_TAG';
// 清除tag
export const REMOVE_TAG = 'REMOVE_TAG';
// 设置tag
export const SET_TAG = 'SET_TAG';
// 选择语言
export const SELECT_LANGS = 'SELECT_LANGS';
// 添加下载任务
export const ADD_DOWNLOAD = 'ADD_DOWNLOAD';
// 获取下载任务
export const GET_DOWNLOADS = 'GET_DOWNLOADS';
// 移除某一项下载任务
export const REMOVE_DOWNLOAD = 'REMOVE_DOWNLOAD';
// 清除所有下载任务
export const REMOVE_DOWNLOADS = 'REMOVE_DOWNLOADS';
// 改变下载任务的状态
export const CHANGE_DOWNLOAD_STATE = 'CHANGE_DOWNLOAD_STATE';
// 保存错误日志
export const SAVE_ERROR_LOG = 'SAVE_ERROR_LOG';
// 获取url参数
export const GET_QUERY = 'GET_QUERY';

//地区更新现在
export const UPDATE_AREA = 'UPDATE_AREA';
